import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useKeydown from "@hooks/useKeydown";
import { useNavigate } from "react-router-dom";
import { InoButton } from "@ino-ui/tv";
import { signOut } from "@server/requests";
import LOCAL_STORAGE from "@utils/localStorage";
import "./styles/VoucherModal.scss";

export default function LogoutModal({ isVisible, onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("cancel");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setActiveButton("cancel");
      setIsLoading(false);
    }
  }, [isVisible]);

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const token = LOCAL_STORAGE.TOKEN.GET();
      if (token) {
        await signOut({ token });
      }
    } catch (error) {
      console.log("Logout error:", error);
    } finally {
      // Clear local storage and redirect regardless of API response
      LOCAL_STORAGE.TOKEN.REMOVE();
      LOCAL_STORAGE.LAST_CHANNEL_ID.REMOVE();
      localStorage.removeItem("parental_code");
      navigate("/");
    }
  };

  useKeydown({
    isActive: isVisible,
    left: () => {
      setActiveButton("cancel");
    },
    right: () => {
      setActiveButton("logout");
    },
    ok: () => {
      if (activeButton === "logout") {
        handleLogout();
      } else {
        onClose();
      }
    },
    back: () => {
      onClose();
    },
  });

  if (!isVisible) return null;

  return (
    <div className={`voucher-modal-overlay ${isVisible ? "visible" : ""}`}>
      <div className="voucher-modal">
        <div className="voucher-header">
          <h2>{t("Logout")}</h2>
          <p>{t("Are you sure you want to logout?")}</p>
        </div>

        <div className="voucher-content">
          <div className="voucher-buttons">
            <InoButton
              className={`voucher-button ${activeButton === "cancel" ? "active" : ""}`}
              onClick={onClose}
              disabled={isLoading}
              isActive={activeButton === "cancel"}
            >
              {t("Cancel")}
            </InoButton>
            <InoButton
              className={`voucher-button logout-confirm-btn ${activeButton === "logout" ? "active" : ""}`}
              onClick={handleLogout}
              disabled={isLoading}
              isActive={activeButton === "logout"}
            >
              {isLoading ? t("Logging out...") : t("Logout")}
            </InoButton>
          </div>
        </div>
      </div>
    </div>
  );
}
